import React, { useEffect, useRef, useState } from 'react';
import { Link } from "react-router-dom";
import { Button, Tooltip, OverlayTrigger,Badge } from "react-bootstrap";
import swal from "sweetalert2";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import Edit from '../../../modal/Branch_Management/Manage_Area/EditArea';
import axios from 'axios';

const Area = () => {
    const [area, setarea] = useState([]);
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [groupedData, setGroupedData] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [perPage, setPerPage] = useState(25);
    const [TotalCount, setTotalCount] = useState('');
    
    // useEffect(() => {
    // axios.get(`${baseURL}/managearea`)
    //     .then(response => {
    //     console.log('API response data:', response.data);
    //     setarea(Array.isArray(response.data.data) ? response.data.data : []);
    //     setHasFetched(true);
    //     })
    //     .catch(error => {
    //     console.error('There was an error fetching the posts!', error);
    //     setHasFetched(true);
    //     });
    // }, []);

    const fetchData = async () => {
        try {
            const params = {
                page,
                per_page: perPage,
                search: searchTerm,
            };
            const response = await axios.get(`${baseURL}/managearea`, { params });
            console.log("API response in fetchData:", response.data);

            // Assuming response.data.data is an object with keys: data, total, last_page
            const apiData = response.data.data;

            if (apiData && Array.isArray(apiData.data)) {
                setarea(apiData.data);
                setTotalCount(apiData.total || 0);
                setTotalPages(apiData.last_page || 1);
            } else if (Array.isArray(response.data.data)) {
            // Fallback if data is directly an array
                setarea(response.data.data);
                setTotalCount(response.data.total || 0);
                setTotalPages(response.data.last_page || 1);
            } else {
                setarea([]);
                setTotalCount(0);
                setTotalPages(1);
            }

            setHasFetched(true);
        } catch (error) {
            console.error('There was an error fetching the data!', error);
            setHasFetched(true);
        }
        };

        useEffect(() => {
            fetchData();
        }, [page, perPage, searchTerm]);

    useEffect(() => {
    if (!Array.isArray(area)) {
        console.warn("area is not an array:", area);
        return; // prevent error
    }

    const grouped = area.reduce((acc, item) => {
        const branchName = item.branch_data.branch_name;
        if (!acc[branchName]) {
        acc[branchName] = {
            branch_name: branchName,
            area: [],
            branch_data: item.branch_data
        };
        }
        acc[branchName].area.push({
        area_name: item.area_name,
        sno: item.sno,
        status: item.status,
        assigned_delivery_point: item.assigned_delivery_point
        });
        return acc;
    }, {});
    setGroupedData(Object.values(grouped));
    }, [area]);

    const tableRef = useRef(null);
    const [modalType, setModalType] = useState("");
    const [open, setOpen] = useState(false);
    const [selectedArea, setSelectedArea] = useState(null);

    const handleModalToggle_Edit = (area) => {
        // console.log('Selected Area for Edit:', area);
        setSelectedArea(area);
        setModalType("Edit");
        setOpen(true);
    };


    // const fetchData = async () => {
    //     try {
    //         const response = await axios.get(`${baseURL}/managearea`);
    //         // console.log("API response:", response.data);
    //         setarea(response.data.data);
    //         setHasFetched(true);
    //     } catch (error) {
    //         console.error('There was an error fetching the posts!', error);
    //         setHasFetched(true);
    //     }
    // };

    // useEffect(() => {
    //     fetchData();
    // }, []);
    

    const DeleteModal = (branchSno) => {
        swal.fire({
            html: `
                 <div class="alert alert-danger px-2 py-2" role="alert">
                     <strong>OOPS! </strong> You're about to lose Area
                     <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                 </div>
                 
                 <div class="text-center">
                     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48" height="48">
                         <defs>
                             <radialGradient id="radial-gradient" cx="-27.957" cy="8.563" r="6" gradientTransform="matrix(3 0 0 2.5 107.871 -4.408)" gradientUnits="userSpaceOnUse">
                                 <stop offset="0" stop-color="#5987dd"/>
                                 <stop offset=".118" stop-color="#638bd6"/>
                                 <stop offset=".316" stop-color="#7d98c3"/>
                                 <stop offset=".572" stop-color="#a8aba3"/>
                                 <stop offset=".871" stop-color="#e3c678"/>
                                 <stop offset="1" stop-color="#ffd364"/>
                             </radialGradient>
                             <style>.cls-3{fill:#ffb32b}.cls-4{fill:#273941}.cls-5{fill:#141e21}.cls-6{fill:#f6fafd}</style>
                         </defs>
                         <g id="_27-feel_bad" data-name="27-feel bad">
                             <circle cx="24" cy="24" r="23" style="fill:#ffce52"/>
                             <ellipse cx="24" cy="17" rx="18" ry="15" style="fill:url(#radial-gradient)"/>
                             <path class="cls-3" d="M46 23c0 10.493-9.85 19-22 19S2 33.493 2 23h-.975c-.014.332-.025.665-.025 1a23 23 0 0 0 46 0c0-.335-.011-.668-.025-1z"/>
                             <ellipse class="cls-4" cx="33" cy="23" rx="3" ry="4"/>
                             <ellipse class="cls-5" cx="33" cy="23" rx="2" ry="3"/>
                             <circle class="cls-6" cx="34" cy="22" r="1"/>
                             <ellipse class="cls-4" cx="15" cy="23" rx="3" ry="4"/>
                             <ellipse class="cls-5" cx="15" cy="23" rx="2" ry="3"/>
                             <circle class="cls-6" cx="16" cy="22" r="1"/>
                             <path class="cls-5" d="M10 19v-2c3.722 0 6-1.295 6-2h2c0 2.626-4.024 4-8 4zM38 19c-3.976 0-8-1.374-8-4h2c0 .705 2.278 2 6 2z"/>
                             <path class="cls-4" d="M24 35h-5.5a5.265 5.265 0 0 1 5.5-5 5.265 5.265 0 0 1 5.5 5z"/>
                             <path class="cls-5" d="M24 31a5.4 5.4 0 0 1 5.39 4h.11a5.265 5.265 0 0 0-5.5-5 5.265 5.265 0 0 0-5.5 5h.11A5.4 5.4 0 0 1 24 31z"/>
                             <path d="M47 12a4 4 0 0 1-8 0c0-2.209 3-8 4-8s4 5.791 4 8z" style="fill:#3bc5f6"/>
                             <path d="M43 4c-1 0-4 5.791-4 8a4 4 0 0 0 8 0c0-2.209-3-8-4-8zm0 8.5a2.848 2.848 0 0 1-3-2.667C40 8.361 42.25 4.5 43 4.5s3 3.861 3 5.333a2.848 2.848 0 0 1-3 2.667z" style="fill:#00a3e1"/>
                             <path class="cls-3" d="M43 16a3.991 3.991 0 0 1-3.861-3.008A4.661 4.661 0 0 0 39 14a4 4 0 0 0 6.846 2.807q-.255-.777-.562-1.529A3.982 3.982 0 0 1 43 16z"/>
                             <ellipse class="cls-6" cx="44" cy="11" rx=".825" ry="1.148" transform="rotate(-45.02 44 11)"/>
                             <ellipse class="cls-6" cx="44.746" cy="9.5" rx=".413" ry=".574" transform="rotate(-45.02 44.746 9.5)"/>
                             <ellipse class="cls-6" cx="36" cy="9" rx=".825" ry="1.148" transform="rotate(-45.02 36 9)"/>
                             <ellipse class="cls-6" cx="29.746" cy="4.5" rx=".413" ry=".574" transform="rotate(-45.02 29.746 4.5)"/>
                             <ellipse class="cls-6" cx="33" cy="7" rx="1.65" ry="2.297" transform="rotate(-45.02 33 7)"/>
                         </g>
                     </svg>
                 </div>
             `,
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'Cancel',
            reverseButtons: true,
            customClass: {
                title: 'fs-6',
                cancelButton: 'btn btn-sm btn-secondary',
                confirmButton: 'btn btn-sm btn-danger',
                htmlContainer: 'text-left'
            },
            allowOutsideClick: false,
            allowEscapeKey: false,
        }).then((result) => {
        if (result.isConfirmed) {
            axios.delete(`${baseURL}/managearea/branch/${branchSno}`)
                .then((response) => {
                    // console.log('Delete success:', response.data);
                    setarea((prevAreas) => prevAreas.filter((item) => item.sno !== branchSno)); // Update state after deletion
                    swal.fire('Deleted!', 'Area has been deleted.', 'success');
                    window.location.reload();
                })
                .catch((error) => {
                    console.error('There was an error deleting the area!', error);
                    swal.fire('Error!', 'There was an error deleting the area.', 'error');
                });
        }
    });
    };



    // useEffect(() => {
    //     if(hasFetched && groupedData.length > 0){
    //     if (tableRef.current) {
    //         if (!$.fn.dataTable.isDataTable(tableRef.current)) {
    //             $(tableRef.current).DataTable({
    //                 "responsive": true,
    //                 pageLength: 25,
    //                 "ordering": false,
    //                 "language": {
    //                     "lengthMenu": "Show&nbsp;&nbsp; _MENU_",
    //                 },
    //                 "dom":
    //                     "<'row'" +
    //                     "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
    //                     "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
    //                     ">" +
    //                     "<'table-responsive'tr>" +
    //                     "<'row'" +
    //                     "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
    //                     "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
    //                     ">"
    //             });
    //         }
    //     }}
    // }, [groupedData, hasFetched]);

    useEffect(() => {
        if (hasFetched && groupedData > 0) {
            if (tableRef.current) {
                if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                    $(tableRef.current).DataTable({
                        "destroy": true,
                        "paging": false,
                        "searching": false,
                        "info": false,
                        "responsive": true,
                        "deferRender": true,
                        pageLength: 25,
                        //   "aaSorting": [],
                        "ordering": false,
                        "language": {
                            "lengthMenu": "Show&nbsp;&nbsp; _MENU_",
                        },
                        "dom":
                            "<'row'" +
                            "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                            "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                            ">" +
                            "<'table-responsive'tr>" +
                            "<'row'" +
                            "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                            "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                            ">"
                    });
                }
            }
        }
    }, [hasFetched, groupedData]);
        


    return (
        <>
            <div className="d-flex align-items-center justify-content-between flex-wrap page-titles px-0 py-1 mx-0">
                <div className='mb-0'>
                    <div className="mb-0 px-0">
                        <h4 style={{ color: '#025d3a' }}>Manage Area</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Branch Management</li>
                    </ol>
                </div>
                {open && modalType === "Edit" && (
                    <Edit show={open} onClose={() => setOpen(false)} area={selectedArea}  onUpdated={fetchData}/>
                )}
            </div>
            <div className='row'>
                <div class="d-flex justify-content-end mb-3">
                    <div class="w-15px h-15px me-2 mt-1 bg-success rounded-1"></div>
                    <label class="text-black fs-6 me-4">Assigned</label>
                    <div class="w-15px h-15px me-2  mt-1 bg-info rounded-1"></div>
                    <label class="text-black fs-6 me-4">Not Assigned</label>
                    <div class="w-15px h-15px me-2  mt-1 bg-danger rounded-1"></div>
                    <label class="text-black fs-6">Blocked</label>
                </div>
            </div>
            <div className="table-container">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    {/* Left: Show entries dropdown */}
                    <div>
                        <label className="me-2">Show</label>
                        <select
                            className="form-select d-inline w-auto"
                            style={{  fontSize: '0.85rem', height: '30px' }}
                            value={perPage}
                            onChange={(e) => {
                                setPerPage(Number(e.target.value));
                                setPage(1); // Reset to first page
                            }}
                        >
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                        </select>
                    </div>

                    {/* Right: Search input */}
                    <div>
                        <input
                            type="text"
                            style={{  fontSize: '0.85rem', height: '40px' }}
                            placeholder="Search..."
                            className="form-control"
                            value={searchTerm}
                            onChange={(e) => {
                                setSearchTerm(e.target.value);
                                setPage(1); // Reset page on new search
                            }}
                        />
                    </div>
                </div>
                <table ref={tableRef} className="table align-top table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                    <thead>
                        <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head align-top">
                            <th className='min-w-250px'>Area</th>
                            <th className='min-w-100px'>Branch</th>
                            <th className='min-w-50px'>Actions</th>
                        </tr>
                    </thead>
                    <tbody className="text-gray-600 fw-semibold fs-7 align-top">
                        {groupedData.map((group, index) => (
                        <tr key={index}>
                            <td>
                                {group.area.map((area, idx) => (
                                <div className='w-400px text-wrap' key={idx}>
                                    {area.assigned_delivery_point === 1 && area.status !== 1 && (
                                    <Badge bg="" className='light badge light badge-success fs-7 py-0 me-2 px-1 mb-1'>{area.area_name}</Badge> 
                                    )}
                                    {area.assigned_delivery_point === 0 && area.status !== 1 && (
                                    <label className='font-w400 badge-info badge light fs-7 me-2 py-0  px-1 mb-1'>{area.area_name}</label>
                                    )}
                                    {area.status === 1 && (
                                    <Badge bg="" className='light badge light badge-danger fs-7 py-0 me-2 px-1 mb-1'>{area.area_name}</Badge>
                                    )}
                                </div>
                                ))}
                            </td>
                            <td>
                                <div className='text-black font-w400 fs-7'>{group.branch_name}</div>
                            </td>
                            <td>
                                <div class="text-end">
                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Edit</span></Tooltip>} >
                                        <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={() => handleModalToggle_Edit(group)}>
                                            <span><i class="fa-solid fa-pen-to-square fs-5 mt-1"></i></span>
                                        </Button>
                                    </OverlayTrigger>
                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Delete</span></Tooltip>} >
                                        <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={() => {
                                            // console.log("Deleting area with ID:", group.area[0].sno); // Check the value
                                            DeleteModal(group.branch_data.sno);}}>
                                            <span><i class="fa-solid fa-trash-can fs-6 mt-1"></i></span>
                                        </Button>
                                    </OverlayTrigger>
                                </div>
                            </td>
                        </tr>
                        ))}
                    </tbody>
                </table>
                <div className="d-flex justify-content-between align-items-center mt-3">
                    {/* Bottom left: Showing x to y of z entries */}
                    <div>
                        {groupedData.length > 0 ? (
                            <span className="text-muted">
                                Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + groupedData.length} of {TotalCount} entries
                            </span>
                        ):(
                            <span className="text-muted">
                                Showing 0 to 0 of 0 entries
                            </span>
                        )}
                    </div>

                    {/* Bottom right: Pagination */}
                    <nav>
                        <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                            <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                            <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>Previous</button>
                            </li>
                            {[...Array(totalPages)].map((_, i) => (
                            <li key={i} className={`page-item ${page === i + 1 ? 'active' : ''}`}>
                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(i + 1)}>{i + 1}</button>
                            </li>
                            ))}
                            <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                            <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>Next</button>
                            </li>
                        </ul>
                    </nav>

                </div>
            </div>



        </>
    )


}
export default Area;